import type { ComponentProps } from 'react';
import * as RadixPopover from '@radix-ui/react-popover';
import { cn } from './cn';

/** Popover root, trigger and anchor (Radix): `<Popover><PopoverTrigger asChild>…</PopoverTrigger><PopoverContent>…` */
export const Popover = RadixPopover.Root;
export const PopoverTrigger = RadixPopover.Trigger;
export const PopoverAnchor = RadixPopover.Anchor;
export const PopoverClose = RadixPopover.Close;

/** Floating panel next to its trigger: portalled, white card with the popover shadow. */
export function PopoverContent({ className, align = 'start', sideOffset = 6, ...props }: ComponentProps<typeof RadixPopover.Content>) {
  return (
    <RadixPopover.Portal>
      <RadixPopover.Content
        align={align}
        sideOffset={sideOffset}
        className={cn('z-50 rounded-lg border border-line bg-surface font-sans text-sm text-ink shadow-pop outline-none', className)}
        {...props}
      />
    </RadixPopover.Portal>
  );
}
